import { Box, Grid, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import { OfficialData } from '@networkRequest/officialsService';
import { Breadcrumbs } from '@components';
import { Button } from '@baseComponents';
import Utils from '../../../utils/utils';
import PinMenu from './PinMenu';
import { PAGE_PATHS } from '../../../constants';

interface UserDetailsHeaderProps {
  official: OfficialData;
  refreshData: () => Promise<void>;
  setEditUserDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setUpdatedPin: React.Dispatch<React.SetStateAction<string | null>>;
  setSharePinDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setError: (string) => void;
}

const UserDetailsHeader = ({
  official,
  refreshData,
  setEditUserDialogOpen,
  setUpdatedPin,
  setSharePinDialogOpen,
  setError,
}: UserDetailsHeaderProps) => {
  const location = useLocation();
  let returnTo = PAGE_PATHS.users;

  if (location?.state?.search?.length) {
    returnTo = returnTo + location.state.search;
  }
  return (
    <Box>
      <Breadcrumbs items={[{ display: 'Users', path: returnTo}]} />
      <Grid container sx={{
        justifyContent: 'space-between'
      }}>
        <Grid>
          <Typography variant='xxl'>
            {Utils.fullName(official.first_name, official.last_name)}
          </Typography>
        </Grid>
        <Grid container spacing={1}>
          <Button
            text='Edit'
            onClick={() => setEditUserDialogOpen(true)}
            mode='outlined'
            startIcon={<EditIcon fontSize='small' sx={{ marginRight: 1 }} />}
          />
          <PinMenu
            officialId={official.id}
            setUpdatedPin={setUpdatedPin}
            setSharePinDialogOpen={setSharePinDialogOpen}
            refreshData={refreshData}
            setError={setError}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default UserDetailsHeader;